module.exports = __webpack_public_path__ + "static/media/book-open.f7d61d34.svg";